import { Grid } from '@mui/material'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { TechGrantSelectors } from '../../../../../store/technology'
import { GrantCard } from './GrantCard'

interface MatchesGridProps {
  handleGrantDetailSlideOut: (projectId: string, refId: string) => void
  fetchGrants:() => void
}

export const MatchesGrid: FC<MatchesGridProps> = ({ fetchGrants ,handleGrantDetailSlideOut }) => {
  const grants = useSelector(TechGrantSelectors.makeGrantsSummary)

  return (
    <Grid my={2} container spacing={2}>
      {grants &&
        grants.map((grant) => {
          const { agency, like,refId, technologyId, topicId, closeDate, _id, title, technologyTitle, formattedAwardAmount } = grant

          return (
            <Grid key={_id} item md={3} sm={6} xs={12} sx={{ cursor: 'pointer' }}
                  onClick={() => handleGrantDetailSlideOut(technologyId, topicId)}>
              <GrantCard
                like={like}
                refId={refId}
                agency={agency}
                grantTitle={title}
                deadline={closeDate}
                projectId={technologyId}
                fetchGrants={fetchGrants}
                technologyTitle={technologyTitle}
                awardAmount={formattedAwardAmount}
              />
            </Grid>
          )
        })}
    </Grid>
  )
}
